export default {
  default: () => import("/builds/laoshi_io/web/teacher-space-web-frontend/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/builds/laoshi_io/web/teacher-space-web-frontend/layouts/empty.vue").then(m => m.default || m),
  mobile: () => import("/builds/laoshi_io/web/teacher-space-web-frontend/layouts/mobile.vue").then(m => m.default || m)
}